import MainPage from 'pages/main';
import SnackPackPage from 'pages/snackpack';
import { Routes, Route } from 'react-router-dom';
import { GroupsContextProvider } from 'stores/groups-context';
import { UserRole } from 'types/user';
import AuthorizationProtected from '../components/authorization-protected';
import MainAdminPage from '../pages/main-admin';
import { DataCertificationsContextProvider } from 'stores/data-certifications-context';
import { JobsContextProvider } from '../stores/jobs-context';
import { RulesContextProvider } from '../stores/rules-context';
import { VariablesContextProvider } from '../stores/variables-context';
import { ADMIN, SNACKPACK,EDFI_CREDINTIAL_MANAGER } from './links';
import AuthenticationProtected from 'components/authentication-protected';
import EDFICredentialPage from 'pages/EDFI-Credentials';

function RootNavigator(): JSX.Element {
  return (
    <AuthenticationProtected>
      <Routes>
        <Route
          path={SNACKPACK + '/*'}
          element={
            <AuthorizationProtected>
              {' '}
              <SnackPackPage />{' '}
            </AuthorizationProtected>
          }
        />
        <Route
          path={ADMIN + '/*'}
          element={
            <AuthorizationProtected requiredRole={UserRole.VALIDATION_PORTAL_ADMIN}>
              <JobsContextProvider>
                <GroupsContextProvider>
                  <RulesContextProvider>
                    <VariablesContextProvider>
                      <DataCertificationsContextProvider>
                        <MainAdminPage />
                      </DataCertificationsContextProvider>
                    </VariablesContextProvider>
                  </RulesContextProvider>
                </GroupsContextProvider>
              </JobsContextProvider>
            </AuthorizationProtected>
          }
        />


          
<Route
 path={EDFI_CREDINTIAL_MANAGER}
 element={
 <AuthorizationProtected 
 requiredRole={UserRole.SECRET_KEY_MASTER}>
 < EDFICredentialPage/>
 </AuthorizationProtected>
 }
 />

        <Route
          path={'*'}
          element={
            <AuthorizationProtected>
              <JobsContextProvider>
                <MainPage />
              </JobsContextProvider>
            </AuthorizationProtected>
          }
        />
      </Routes>
    </AuthenticationProtected>
  );
}

export default RootNavigator;
